
// @ts-nocheck
import locale__codebuild_output_src3758341090_src_packages_frontend_i18n_locales_en from "../i18n/locales/en";
import locale__codebuild_output_src3758341090_src_packages_frontend_i18n_locales_de from "../i18n/locales/de";


export const localeCodes =  [
  "en",
  "de"
]

export const localeLoaders = {
  "en": [{ key: "../i18n/locales/en", load: () => Promise.resolve(locale__codebuild_output_src3758341090_src_packages_frontend_i18n_locales_en), cache: true }],
  "de": [{ key: "../i18n/locales/de", load: () => Promise.resolve(locale__codebuild_output_src3758341090_src_packages_frontend_i18n_locales_de), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n/i18n.config.ts?hash=5b32d2e0&config=1" /* webpackChunkName: "i18n_config_5b32d2e0" */)
]

export const nuxtI18nOptions = {
  "restructureDir": "i18n",
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false,
    "typedPages": true,
    "typedOptionsAndMessages": false,
    "generatedLocaleFilePathFormat": "absolute",
    "alternateLinkCanonicalQueries": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false,
    "optimizeTranslationDirective": true
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "language": "en",
      "name": "English",
      "files": [
        "/codebuild/output/src3758341090/src/packages/frontend/i18n/locales/en"
      ]
    },
    {
      "code": "de",
      "language": "de",
      "name": "deutsch",
      "files": [
        "/codebuild/output/src3758341090/src/packages/frontend/i18n/locales/de"
      ]
    }
  ],
  "defaultLocale": "",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": false,
  "langDir": "locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "language": "en",
    "name": "English",
    "files": [
      {
        "path": "/codebuild/output/src3758341090/src/packages/frontend/i18n/locales/en"
      }
    ]
  },
  {
    "code": "de",
    "language": "de",
    "name": "deutsch",
    "files": [
      {
        "path": "/codebuild/output/src3758341090/src/packages/frontend/i18n/locales/de"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
